<template>
  <div id="contenedor-agregar-nuevo-programainversion">
    <v-card>
      <v-form v-model="formularioValido" ref="agregarProgramaInversion">
        <v-card-title class="secondary--text">
          Registrar nuevo programa de inversión
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            label="Ejercicio"
            :items="itemsejercicio"
            v-model="programaInversion.ejercicio"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-select>
          <custom-text-field
            label="Clave"
            v-model="programaInversion.clave"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <custom-text-field
            label="Nombre del Programa de Inversión"
            v-model="programaInversion.nombre"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <custom-select
            label="Normatividad"
            :items="itemsnormatividad"
            v-model="programaInversion.normatividad"
            item-text="origen"
            item-value="valor"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-select>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarProgramaInversion"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoProgramasInversion from './mixCatalogoProgramasInversion';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosProgramasInversionNuevo',
  mixins: [mixCatalogoProgramasInversion],
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      itemsnormatividad: [
        { origen: 'Federal', valor: 1 },
        { origen: 'Estatal', valor: 2 },
      ],
      itemsejercicio: [2021, 2022, 2023],
      programaInversion: {
        ejercicio: 0,
        clave: '',
        nombre: '',
        normatividad: 0,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.agregarProgramaInversion.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
